import { render, staticRenderFns } from "./Thumb.vue?vue&type=template&id=790fd73a&"
import script from "./Thumb.vue?vue&type=script&lang=js&"
export * from "./Thumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports